import { render, staticRenderFns } from "./VAdministrationPrimaryTable.vue?vue&type=template&id=28dde82e&"
import script from "./VAdministrationPrimaryTable.vue?vue&type=script&lang=ts&"
export * from "./VAdministrationPrimaryTable.vue?vue&type=script&lang=ts&"
import style0 from "./VAdministrationPrimaryTable.vue?vue&type=style&index=0&id=28dde82e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports